import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';


export interface DatenverwaltungPlausibilisierungState {
    data: Array<any>;
    formValues: any;
}

export class DatenverwaltungPlausibilisierung extends React.Component<{}, DatenverwaltungPlausibilisierungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: [],
            formValues: {}
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    private bundleBbereich: Array<any>;

    render(): JSX.Element {
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_PLAUSIBILISIERUNG}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    defaultSorted={[{ id: 'parameter', asc: true }]}
                    onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_PLAUSIBILISIERUNG)}
                    showColumnsHelp={true}
                    onDataLoaded={(data: Array<any>) => this.setState({ data })}
                    validateField={(key: string, value: any, data: any, onValueChange: (name: string, value: any, doValidate?: boolean) => void) => {
                        this.setState({ formValues: data.values });
                        if (key === 'bereich_key') {
                            if (this.findExistRow(value)) {
                                onValueChange(key, null, false);
                                return 'Der identische Entrag existiert.';
                            }
                        }
                        return null;
                    }}
                    bundleFilterFunc={(bundle: any) => {
                        if (Array.isArray(bundle.bereich_key)) {
                            if (!this.bundleBbereich) {
                                this.bundleBbereich = bundle.bereich_key;
                            }
                            bundle.bereich_key = this.bundleBbereich.filter((b: any) => !this.findExistRow(b.intern_key));
                        }
                        return bundle;
                    }}
                    onAfterAction={(action: string) => {
                        if (action.startsWith('closeForm')) {
                            this.setState({ formValues: {} });
                        }
                    }}
                />
            </div>
        );
    }

    findExistRow(bereichKey: string) {
        const { data, formValues } = this.state;
        const fnd = data.find((r: any) => r.tid !== formValues.tid && r.parameter === formValues.parameter && this.validBKey(r.bereich_key_orig) === this.validBKey(bereichKey));
        return fnd;
    }

    validBKey(val: any) {
        if (!val) {
            return '';
        }
        return val;
    }
}
